import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Documents } from './s'
import { Field, Label } from 'components/form/field/s'
import Dokument from './dokument'

const DocumentReferences = ({ dokuments = [], preview }) => (
    <Field>
        <Label>
            <FormattedMessage
                id="documents_smart_label_pdf_references"
                defaultMessage="Derived PDF documents" />
        </Label>
        <Documents>
            {dokuments.map(dokument => (
                <Dokument
                    dokument={dokument}
                    preview={preview}
                    key={dokument.id} />
            ))}
        </Documents>
    </Field>
)

export default DocumentReferences